import { LogLevel } from '@nts/std/src/lib/utility';

export const environment = {
  production: true,
  baseAppUrl: window.location.protocol + '//' + (window.location.hostname) + (window.location.port ? `:${window.location.port}` : ''),
  authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
  prefixApi: '/api',
  envType: 'DEV',
  appTitle: 'LoginService - DEV',
  appSubTitle: '',
  logLevel: LogLevel.All,
  isEnterpriseBarrierRequired: false
};
